import Button from 'components/helpers/Button';
import { classnames } from 'tailwindcss-classnames';
import { HitProps } from './_types';
import { getReportDownloadUrl } from 'lib/util/algolia';
import { defaultSearchHitDataLayerHandler } from '../util';

type HeadlineProps = HitProps & React.HTMLAttributes<HTMLElement>;

export const ReportHeading = ({ hit, children }: HeadlineProps) => {
  const headlineClass = classnames(
    'text-blue',
    'text-m',
    'leading-4',
    'mb-2',
    'line-clamp-3',
    'sm:text-lg',
    'sm:leading-6',
    'md:line-clamp-1'
  );

  const href = getReportDownloadUrl(hit.objectID);

  return (
    <h3 className={headlineClass}>
      <Button
        linkField={{ value: { href: href } }}
        variant="link"
        suppressLinkText="true"
        onGtmPush={(props) => defaultSearchHitDataLayerHandler({ ...props, hit })}
      >
        {children}
      </Button>
    </h3>
  );
};
